import { mapActions, mapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';
import util from '../../common/util';
import { unformats } from '../../common/format';
import { getFromDetailPageParam } from '@/common/business/agent-detail';
import questionnaire from '../../components/questionnaire';
import vForm from '../../components/v-form.vue';
import vInput from '../../components/v-input.vue';
import {
    setRegisStatus,
    registrationEnum,
    state as regState
} from '@/components/sign-log/register-track';
import AutoRegister from '../../common/autoRegister';
import ThirdBox from './thirdBox.vue';
import { leadTypes, isBuyer, isSeller, isAgent } from '@/common/const';
import popMgr from '@/components/global/popMgr';
import agentLeadDialog from '@/components/sign-log/agent-lead-dialog.vue';
import { INTERCEPT_URL } from '@/common/customize';
import { getPhysicalInfo } from '@/common/getPhysicalInfo.js'
export default {
    data: function() {
        return {
            facebookDisabled: true,
            gmailDisabled: true,
            facebookWaiting: false,
            gmailWaiting: false,
            authData: (this.options && this.options.authData) || null,
            registerData: {},
            thirdParty: '',
            fbLoginStatus: {},
            thirdPartErrorShow: false,
            thirdPartErrorMsg: ''
            // fbUser: null
        };
    },
    inject: {
        display: {
            from: 'display',
            default: () => {}
        }
    },
    computed: {
        ...mapState(usePageStore, ['page', 'hasEmailLead']),
        ...mapState(useUserStore, ['user']),
        isFbLead() {
            return util.getCookie('_ads_source') === '15' && this.facebook;
        },
        ignoreBuyerPhone({ page }) {
            return !!(page.registration && page.registration.ignoreBuyerPhone);
        },
        ignoreSellerPhone({ page }) {
            return !!(page.registration && page.registration.ignoreSellerPhone);
        },
        toastMsg({ page }) {
            return (
                page.registration?.toast || this.$t('common:register.toastMsg')
            );
        },
        role({ page }) {
            return page.registerUserType || leadTypes.Buyer;
        },
        inquiry({ page }) {
            let inquiry = true;
            if (isAgent(this.role) || this.isRegisterAgentLead) {
                inquiry  = false;
            } else if (isBuyer(this.role)) {
                inquiry = !!(page.questionNaire && page.questionNaire.inquiry);
            } else if (isSeller(this.role)) {
                inquiry = !!(
                    page.questionNaire && page.questionNaire.inquirySeller
                );
            } else {
                inquiry = false;
            }
            return inquiry;
        },
        ignorPhone() {
            if (this.role === leadTypes.Buyer) {
                return this.ignoreBuyerPhone;
            } else {
                return this.ignoreSellerPhone;
            }
        }
        // fbPicture() {
        //     return this.fbUser && this.fbUser.picture
        //         ? this.fbUser.picture.data.url
        //         : false;
        // },
        // fbFirstName() {
        //     return this.fbUser
        //         ? this.fbUser.first_name || this.fbUser.name
        //         : false;
        // }
    },
    mounted() {
        // this.showFacebook &&
        //     facebook.prepare().then(FB => {
        //         FB.getLoginStatus(({ status }) => {
        //             if (status === 'connected') {
        //                 FB.api(
        //                     '/me',
        //                     'GET',
        //                     {
        //                         fields: 'picture,email,id,first_name,name,last_name'
        //                     },
        //                     res => {
        //                         if (!res.error) {
        //                             this.fbUser = res;
        //                         }
        //                     }
        //                 );
        //             }
        //         }, true);
        //         this.facebookDisabled = false;
        //     });

        this.autoRegisterInstance = AutoRegister.getInstance(
            this,
            this.hasEmailLead
        );
        this.autoRegisterInstance.start();
        this.$nextTick(() => {
            if (this.options.showThirdNext) {
                this.autoRegisterInstance.emit('emailLead-register');
            }
        });

        //  from  facebook app  of  url
        if (this.options?.facebook_app_auth_data) {
            window.setTimeout(() => {
                this.authCallback({
                    data: this.options.facebook_app_auth_data,
                    thirdParty: 'facebook'
                });
            }, 200);
        }
    },
    beforeUnmount() {
        this.autoRegisterInstance && this.autoRegisterInstance.destroy();
    },
    methods: {
        ...mapActions(useUserStore, ['login', 'updateUser']),
        ...mapActions(usePageStore, ['getCustomParams']),
        //  Authorization successful callback
        authCallback({ data, error, thirdParty }) {
            if (error) {
                this.onTrack && this.onTrack(thirdParty, regState.fail, error);
            } else {
                this.thirdParty = thirdParty;
                data.role = this.role;
                this.authData = data;
                if (this.onTrack) {
                    this.onTrack(thirdParty, regState.success);
                    setRegisStatus({
                        registrationType:
                            thirdParty === 'google'
                                ? registrationEnum.registrationType.gmail
                                : registrationEnum.registrationType.fb
                    });
                }
                this.thirdPartySignLog();
                //  After the third-party authorization is successful, the user information is obtained to trigger the automatic countdown registration logic in the background
                this.autoRegisterInstance.emit('emailLead-register');
            }
        },
        // fackbookClick() {
        //     if (
        //         this.type &&
        //         this.type === 'register' &&
        //         this.agreeEle &&
        //         !this.agreeEle.checked
        //     ) {
        //         if (this.onTrack) {
        //             this.onTrack(this.regType.facebook, regState.fail);
        //         }
        //         util.toast(
        //             'Please select approval with the agreement'
        //         );
        //     } else {
        //         if (this.facebookDisabled) return;
        //         if (this.fbUser) {
        //             this.thirdParty = 'Facebook';
        //             const { email, id, first_name, name, last_name } =
        //                 this.fbUser;
        //             this.authData = {
        //                 email,
        //                 firstName: first_name,
        //                 fullname: name,
        //                 lastName: last_name,
        //                 uid: id,
        //                 from: 'FACEBOOK',
        //                 role: this.role
        //             };
        //             this.$EventBus.$emit('emailLead-register');
        //             this.thirdPartySignLog();
        //             return;
        //         }
        //         this.facebookWaiting = true;
        //         facebook.authorize(this.$root, (authData, error) => {
        //             if (authData) {
        //                 this.authData = authData;
        //                 this.thirdParty = 'Facebook';
        //                 this.onTrack &&
        //                     this.onTrack(
        //                         this.regType.facebook,
        //                         regState.success
        //                     );
        //                 this.onTrack &&
        //                     setRegisStatus({
        //                         registrationType:
        //                             registrationEnum.registrationType.fb
        //                     });
        //                 this.thirdPartySignLog();
        //                 //  After the third-party authorization is successful, the user information is obtained to trigger the automatic countdown registration logic in the background
        //                 this.$EventBus.$emit('emailLead-register');
        //             } else {
        //                 this.facebookWaiting = false;
        //                 this.onTrack &&
        //                     this.onTrack(
        //                         this.regType.facebook,
        //                         regState.fail,
        //                         error
        //                     );
        //             }
        //         });
        //     }
        // },
        // gmailInit(auth2) {
        //     this.google_target = this.$refs.gmail;
        //     auth2.attachClickHandler(
        //         this.google_target,
        //         {},
        //         googleUser => {
        //             const token = googleUser.getAuthResponse().id_token;
        //             const profile = googleUser.getBasicProfile();
        //             const uid = profile.getId();
        //             const firstName = profile.getGivenName() || '';
        //             const lastName = profile.getFamilyName() || '';
        //             const email = profile.getEmail() || '';
        //             const from = 'GOOGLE';
        //             this.authData = {
        //                 uid,
        //                 from,
        //                 email,
        //                 firstName,
        //                 lastName,
        //                 token,
        //                 role: this.role
        //             };
        //             this.thirdParty = 'Gmail';
        //             this.onTrack &&
        //                 this.onTrack(this.regType.google, regState.success);
        //             this.onTrack &&
        //                 setRegisStatus({
        //                     registrationType:
        //                         registrationEnum.registrationType.gmail
        //                 });
        //             this.thirdPartySignLog();
        //             //  After the third-party authorization is successful, the user information is obtained to trigger the automatic countdown registration logic in the background
        //             this.$EventBus.$emit('emailLead-register');
        //         },
        //         error => {
        //             this.gmailWaiting = false;
        //             this.onTrack &&
        //                 this.onTrack(
        //                     this.regType.google,
        //                     regState.fail,
        //                     error.error
        //                 );
        //         }
        //     );
        // },
        // gmailClick() {
        //     if (
        //         this.type &&
        //         this.type === 'register' &&
        //         this.agreeEle &&
        //         !this.agreeEle.checked
        //     ) {
        //         util.toast(
        //             'Please select approval with the agreement'
        //         );
        //         if (this.onTrack) {
        //             this.onTrack(this.regType.google, regState.fail);
        //         }
        //     } else {
        //         if (this.gmailDisabled) return;
        //         if (this.google_target) {
        //             this.gmailWaiting = true;
        //             this.google_target.click();
        //         }
        //     }
        // },
        //  Execute the callback and pop up a prompt box
        onThirdPartCallback(callback, isToast, toast) {
            if (
                util.call(callback, null, this.user, this.inquiry) !== false &&
                isToast &&
                toast
            ) {
                util.toast(toast);
            }
        },
        thirdPartySignLog() {
            this.axiosIns
                .post('/api-site/third-party/login', this.authData)
                .then(res => {
                    const resData = res.data;
                    const user = resData.user;
                    this.$EventBus.$emit('siteTrack', {
                        ...this.authData,
                        user: user,
                        trackType: 'ThirdPartyLogin',
                        ele: this.$el
                    });
                    this.hasRegisterAgentLead(this.authData.email).then(isAgentLead => {
                        if (isAgentLead) {
                            popMgr.create(agentLeadDialog, {
                                isRegister: true,
                            });
                        } else if (user) {
                            //  Already registered
                            if (resData.leadAccid && resData.leadToken) {
                                user.leadAccid = resData.leadAccid;
                                user.leadToken = resData.leadToken;
                            }
                            this.login({ user });
                            this.thirdPartyOnLogin();
                        } else {
                            const postData = Object.assign(
                                this.authData,
                                {
                                    account: this.authData.email,
                                    role: this.role
                                },
                                this.registerData || {}
                            );
                            postData.canAssignToLender = true;
                            this.authData = postData;
                            //  have email ， And if the mobile phone is not required, it will be automatically registered
                            if (postData.account && this.ignorPhone) {
                                this.isAutoRegister = true;
                                this.thirdPartyRegisterNext(postData);
                            } else {
                                //  if no email ， You need to call after backfilling the login box /third-party/register interface to register
                                this.isAutoRegister = false;
                                this.showThirdPartyRegister();
                                //  when from  URL  When the parameters are authorized ， Because the pop-up window is closed by default ， At this time, you need to open the pop-up window ， Used to fill in the mobile phone number
                                this.display && this.display(true, false, true);
                            }
                        }
                    })
                })
                .catch(error => {
                    this.$EventBus.$emit('siteTrack', {
                        ...this.authData,
                        errorData: error,
                        trackType: 'ThirdPartyLogin-fail',
                        ele: this.$el
                    });
                    this.thirdPartyLoginError(error);
                });
        },
        thirdPartyOnLogin() {
            this.onThirdPartCallback(null, true, 'Login successfully!');
        },
        thirdPartyLoginError(error) {
            this.facebookWaiting = false;
            this.gmailWaiting = false;
            if (!error.error) {
                this.showThirdPartyError(error.errorInfo || 'login error');
            }
        },
        async thridPartFormatDate(data, formatFun) {
            data.phoneNumber = data.phone || '';
            data.account = data.email || '';
            data.fullname = data.fullname || '';
            let mName = data.fullname.match(/([\S]+)(?: +([\S\s]+))?/) || [
                null,
                ''
            ];
            data.firstName = data.firstName || mName[1] || '';
            data.lastName = data.lastName || mName[2] || '';
            if (!data.fullname) {
                data.fullname = data.firstName + ' ' + data.lastName;
            }
            data.phoneNumber = unformats.number(data.phoneNumber || '');
            data.roles =
                data.role || this.role || (this.options && this.options.role);
            data.finishLoginStatus = !isAgent(data.roles);
            data.canAssignToLender = data.role === leadTypes.Buyer ? true : false;
            data.pageUrl = window.location.href;
            // listingId and isSoldListing  rear end GlobalData Give
            if (this.page.listingId !== undefined) {
                data.listingId = this.page.listingId;
            }
            if (this.page.isSoldListing !== undefined) {
                data.sold = this.page.isSoldListing;
            }
            // TCPA consent
            let customParams = this.getCustomParams(INTERCEPT_URL.leadRegister);
            let physicalInfo = await getPhysicalInfo();
            customParams.physicalInfo = physicalInfo;
            Object.assign(data, customParams)

            let campaignId = util.getQueryField('campaignId');
            if (campaignId) {
                data.campaignId = campaignId;
            }
            util.call(formatFun, null, data);
        },
        thirdPartyRegisterNext(data) {
            this.thridPartFormatDate(data).then(_ => {
                return this.thirdPartyRegister(data);
            });
            
        },
        thirdPartyAutoRegister(data) {
            this.thridPartFormatDate(data).then(_ => {
                if (!data || !data.account) {
                    return; 
                }
                this.axiosIns.post('/api-site/auto/leadRegister', { ...data, callOptIn: false, textOptIn: false });
            })
        },
        hasRegisterAgentLead(account) {
            return this.axiosIns.get(`/api-site/check-agent-lead?account=${account}&t=${Date.now()}`).then(res => {
                return res?.data?.agentLead;
            }).catch(err => {
                console.log(err);
                return false;
            })
        },
        async thirdPartyRegister(data) {
            //  no data  or email register
            if (!data || !data.account) {
                return; 
            }
            return this.axiosIns
                .post('/api-site/third-party/register', getFromDetailPageParam(data))
                .then(res => {
                    this.destroy();
                    const resData = res.data;
                    const user = resData.user;
                    if (resData.leadAccid && resData.leadToken) {
                        user.leadAccid = resData.leadAccid;
                        user.leadToken = resData.leadToken;
                    }
                    this.$EventBus.$emit('siteTrack', {
                        ...data,
                        trackType: 'register',
                        id: user?.id,
                        teamId: user?.teamId,
                        ele: this.$el
                    });
                    if (!isAgent(data.roles)) {
                        this.login({ user });
                    }
                    //  questionnaire
                    this.inquiry && questionnaire.prepare(undefined, this.page);
                    
                    //  If it is automatically registered ， It is necessary to further determine whether the phone number is required ， whether or not fblead
                    if (this.isAutoRegister) {
                        this.thirdPartyOnRegister();
                    } else { // not auto-registration ， sign up by backfilling the form
                        this.thirdShowQuestionnaire();
                    }
                    this.onTrack &&
                        this.onTrack(this.regType.register, regState.success);
                })
                .catch(error => {
                    this.$EventBus.$emit('siteTrack', {
                        from: this.authData.from,
                        errorData: error,
                        trackType: 'lead-register-fail',
                        ele: this.$el
                    });
                    this.thirdPartyRegisterError(error);
                    this.onTrack &&
                        this.onTrack(this.regType.register, regState.fail);
                });
        },
        //  call internal register third-party/register interface to get user after the data
        thirdPartyOnRegister() {
            if (this.isFbLead) {
                this.onThirdPartCallback(null, true, this.toastMsg);
            } else {
                // The logic of the reference is supplemented and perfected
            }
        },
        thirdPartyRegisterError(error) {
            this.facebookWaiting = false;
            this.gmailWaiting = false;
            //  Enable registration button
            this.submitDisabled = false;
            if (!error.error) {
                this.showThirdPartyError(
                    error.errorInfo || this.$t('common:register.registerError')
                );
            }
        },
        showThirdPartyRegister(data) {
            // The logic of the reference is supplemented and perfected
        },
        showThirdPartyError(msg) {
            this.thirdPartErrorShow = true;
            this.thirdPartErrorMsg = msg;
            util.timeout({
                handler: () => {
                    this.thirdPartErrorShow = false;
                    this.thirdPartErrorMsg = '';
                },
                delay: 3000,
                unique: true
            });
        },
        thirdRegisterSubmit(form, data) {
            this.$EventBus.$emit('siteTrack', {
                ...data,
                from: this.authData.from,
                trackType: 'lead-register-submit',
                ele: this.$el
            });
        },
        thirdRegisterSubmitSuccess(data) {
            if (this.thirdSubmitDisabled) {
                return; 
            }
            this.thirdSubmitDisabled = true;
            //  If it is automatically registered ， At this point only the phone needs to be updated
            if (this.isAutoRegister) {
                return this.updatePhoneNum(data).finally(_ => {
                    this.thirdSubmitDisabled = false;
                });
            } else {
                return this.thirdPartyRegisterNext(
                    Object.assign({}, this.authData, data)
                ).finally(_ => {
                    this.thirdSubmitDisabled = false;
                });
            }
        },
        async updatePhoneNum(data) {
            if (!data.phone) {
                this.thirdShowQuestionnaire();
                return Promise.resolve();
            } else {
                const phoneNumber = unformats.number(data.phone);
                // TCPA consent
                let customParams = this.getCustomParams(INTERCEPT_URL.updatePhone);
                let physicalInfo = await getPhysicalInfo();
                customParams.physicalInfo = physicalInfo;
                const params = {
                    phoneNumber,
                    ...customParams
                }
                return this.axiosIns
                    .post('/api-site/profile/update/phoneNumber', params)
                    .then(() => {
                        this.destroy();
                        this.updateUser({ phoneNumber });
                        this.thirdShowQuestionnaire();
                    })
                    .catch(error => {
                        this.thirdShowQuestionnaire();
                        console.log(error);
                    });
            }
        },
        thirdOpenQuestionnaire(options, type) {
            questionnaire.open({ options, type, globalData: this.page });
        },
        thirdShowQuestionnaire() {
            if (this.inquiry) {
                const type = isSeller(this.role) ? 1 : 0;
                const options = {
                    noToast: true,
                    closeCallback: () => {
                        this.onThirdPartCallback(null, true, this.toastMsg);
                    }
                };
                this.thirdOpenQuestionnaire(options, type);
            } else {
                this.onThirdPartCallback(null, true, this.toastMsg);
            }
        },
        thirdRegisterSumbitError(errorInfo) {
            this.$EventBus.$emit('siteTrack', {
                from: this.authData.from,
                errorInfo,
                trackType: 'lead-register-submit-fail',
                ele: this.$el
            });
            this.onTrack && this.onTrack(this.regType.register, regState.fail);
        }
    },
    components: {
        'v-form': vForm,
        'v-input': vInput,
        ThirdBox
    }
};
